import { GatsbyLinkProps } from "@mgdx-libs/link";
import { cva, VariantProps } from "cva";
import React from "react";

import { Button } from "./Button";
import * as styles from "./Button.module.css";
import { ButtonExternalLink } from "./ButtonExternalLink";
import { ButtonLink } from "./ButtonLink";

export const variants = cva({
  base: styles.base,
  variants: {
    variant: {
      solid: styles.solid,
      filled: styles.filled,
      outlined: styles.outlined,
    },
    color: {
      key: styles.key,
      caution: styles.caution,
      invariable: styles.invariable,
    },
    loading: {
      true: styles.loading,
      false: "",
    },
  },
  defaultVariants: {
    variant: "solid",
    loading: false,
  },
});

type CommonProps = {
  disabled?: boolean;
  children?: React.ReactNode;
};

export type ButtonProps = VariantProps<typeof variants> & React.ButtonHTMLAttributes<HTMLButtonElement> & CommonProps;
export type ButtonGatsbyLinkProps = VariantProps<typeof variants> &
  Omit<GatsbyLinkProps<EmptyObject>, "ref"> &
  CommonProps;
export type ButtonLinkProps = VariantProps<typeof variants> &
  React.AnchorHTMLAttributes<HTMLAnchorElement> &
  CommonProps;

export { Button, ButtonExternalLink, ButtonLink };
